import { QueryAPIKey } from "utils/constants/api.constants";
import { IProjectGQLResponseData } from "../../project/useProjectData.models";
import queries from "../../queries";

export const projectInvitationsQueryConfig = {
  projectInvitations: {
    query: queries.projectInvitations.getProjectInvitations,
    queryKey: [QueryAPIKey.GetProjectInvitations],
    errorMessageKey: "getProjectInvitationsFailure",
    queryOptions: {
      select: (data: IProjectGQLResponseData) => data.summary.project?.metadata,
    },
  },
};
